import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { Ec2Service } from '../../service';

export type SecurityGroupDetailsConfig = typeof SecurityGroupDetailsConfig._.Config;

export const SecurityGroupDetailsConfig = IntegrationConfig.make({
  service: Ec2Service,
  name: Integration_Handler_Names_Enum.SecurityGroupDetails,
  configSchema: z.object({
    securityGroupId: z.string(),
  }),
});
